import { useRouter } from "next/router";
import { useSnackbar } from "notistack";

import { useCurrentUserContext } from "../contexts/CurrentUserContext";
import { isOrganizationRoute } from "../helpers/auth";
import { clearStoredFilters } from "../helpers/filters";
import { trpc } from "../helpers/trpc";
import { setLastOrganizationId } from "../helpers/userView";

import { useRedirect } from "./useRedirect";
import { useTranslate } from "./useTranslate";

import { useLocaleContext } from "@/common/contexts/LocaleContext";

export const useSwitchOrganization = (): ((organizationId: string) => Promise<boolean>) => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const { refetchOrganization } = useCurrentUserContext();
  const { redirectToDefault } = useRedirect();
  const { isoLocale } = useLocaleContext();
  const router = useRouter();
  const { mutateAsync: setUserCurrentOrganization } = trpc.setUserCurrentOrganization.useMutation();

  return async (organizationId: string) => {
    const { error } = await setUserCurrentOrganization({ targetOrganizationId: organizationId });
    if (error) {
      enqueueSnackbar(t("dashboard", "snackbar.error.switchOrganization"), { vibe: "danger" });
      return false;
    }

    setLastOrganizationId(organizationId);
    clearStoredFilters();

    if (isOrganizationRoute(router.pathname)) {
      await router.reload();
    } else {
      await refetchOrganization();
      await redirectToDefault({ reload: true, isoLocale });
    }
    return true;
  };
};
